import { useContext } from 'react'
import { FormContext } from '@/components/changeRequests/formContext'
import { useReduxState } from '@/hooks/reduxState'
import isEqual from 'lodash/isEqual'

export function useApprovalInfo (propertyProps) {
  const context = useContext(FormContext)
  const state = useReduxState((state) => {
    const { uid, name, target, parentUid } = propertyProps
    const data = state.forms.getIn(['data', parentUid || uid])
    const approvalName = target ? (target + '.' + name) : name
    const approving = !!data && !!data.get('savingApproval')
    let approvalInfo = !!data && data.get('approvalInfo')
    let approved = null
    if (approvalInfo) {
      approvalInfo = approvalInfo.filter((v, k) => k.startsWith(approvalName))
      if (approvalInfo.size > 0) {
        if (approvalInfo.filter(v => v === false).size > 0) approved = false
        else if (approvalInfo.filter(v => v === true).size === approvalInfo.size) approved = true
      }
    }
    return {
      approvalInfo,
      approved,
      approving,
      approvalName,
      needApproval: data.hasIn(['approvalInfo', approvalName]),
      showReviewButtons: state.forms.get('showReviewButtonsFor') === approvalName
    }
  }, isEqual)

  return {
    name: propertyProps.name,
    uid: context.uid,
    target: context.target,
    ...state
  }
}



// WEBPACK FOOTER //
// ./src/hooks/useApprovalInfo.js